import { ControlUsers } from '../sections/controlUsers';
import { useEffect } from "react";
//Redux
import { useSelector } from "react-redux";
//Components
import { Dashboard } from "../sections/dashboard";
import { Clients } from "../sections/clients";
//Styles
import "./style.css";

export const Body = () => {
  const componentActive = useSelector((state) => state.aplicationConfig.userConfig.componentActive);

  const handleComponent = () => {
    let component = <></>;
    switch (componentActive) {
      case "dashboard":
        component = <Dashboard />;
        break;
      case "controlUsers":
        component = <ControlUsers />;
        break;
      case "clients":
        component = <Clients />;
        break;
      default:
        break;
    }
    return component;
  };

  useEffect(() => {
    document.getElementById("adminBody").scrollTo(0, 0);
  }, [componentActive]);

  return (
    <div className="adminBody" id="adminBody">
      {handleComponent()}
    </div>
  );
};
